import React, { useEffect, useState } from 'react';
import InputBase from '@material-ui/core/InputBase';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

export type NumericEntryProps = {
  value: number;
  onChange?: (value: number) => void;
  fixed?: number;
  isNofixed?: boolean; //小数点有り無し設定
  className?: string;
};

const NumericEntry: React.FC<NumericEntryProps> = (props: NumericEntryProps) => {
  const initVal = props.fixed ? props.value.toFixed(props.fixed) : props.value.toString();
  const isNoFixed = props.isNofixed === null ? false : props.isNofixed;
  const [val, setVal] = useState<string>(initVal);

  useEffect(() => {
    setVal(initVal);
  }, [props.value]);

  return (
    <FormControl>
      <InputBase
        className={'MuiInput-underline' + ' ' + props.className}
        value={val}
        inputProps={{ style: { textAlign: 'right' } }}
        onChange={(e) => {
          if (!isNoFixed) {
            const iv = parseFloat(e.target.value);
            if (!isNaN(iv)) {
              setVal(e.target.value);
            } else {
              setVal('0');
            }
          } else {
            const iv = parseInt(e.target.value, 10);
            if (!isNaN(iv)) {
              setVal(String(iv));
            } else {
              setVal('0');
            }
          }
        }}
        onBlur={(e) => {
          if (!isNoFixed) {
            const cv = parseFloat(val);
            if (!isNaN(cv)) {
            }
            setVal(props.fixed ? cv.toFixed(props.fixed) : cv.toString());
            if (props.onChange) {
              props.onChange(cv);
            }
          } else {
            const cv = parseInt(val, 10);
            if (!isNaN(cv)) {
            }
            setVal(props.fixed ? cv.toFixed(props.fixed) : cv.toString());
            if (props.onChange) {
              props.onChange(cv);
            }
          }
        }}
      />
    </FormControl>
  );
};

export default NumericEntry;
